"use strict";

import { schedulePaymentsConstants } from "../_constants";

export const schedulePaymentsListRequest = (payload) => {
  return {
    type: schedulePaymentsConstants.SCHEDULE_PAYMENTS_LIST_REQUEST,
    payload,
  };
};

export const schedulePaymentsListComplete = (payload) => {
  return {
    type: schedulePaymentsConstants.SCHEDULE_PAYMENTS_LIST_COMPLETE,
    payload,
  };
};

export const schedulePaymentsListError = (payload) => {
  return {
    type: schedulePaymentsConstants.SCHEDULE_PAYMENTS_LIST_ERROR,
    payload,
  };
};

export const setActiveView = (payload = null) => {
  return {
    type: schedulePaymentsConstants.SET_ACTIVE_VIEW,
    payload,
  };
};

export const setSchedulePaymentsDetails = (payload) => {
  return {
    type: schedulePaymentsConstants.SET_SCHEDULE_PAYMENTS_DETAILS,
    payload,
  };
};

export const changeIterationStatusRequest = (payload) => {
  return {
    type: schedulePaymentsConstants.CHANGE_ITERATION_STATUS_REQUEST,
    payload,
  };
};

export const changeIterationStatusComplete = (payload) => {
  return {
    type: schedulePaymentsConstants.CHANGE_ITERATION_STATUS_COMPLETE,
    payload,
  };
};

export const changeIterationStatusError = (payload) => {
  return {
    type: schedulePaymentsConstants.CHANGE_ITERATION_STATUS_ERROR,
    payload,
  };
};

export const scheduleIterationListRequest = (payload) => {
  return {
    type: schedulePaymentsConstants.SCHEDULE_ITERATION_LIST_REQUEST,
    payload,
  };
};

export const scheduleIterationListComplete = (payload) => {
  return {
    type: schedulePaymentsConstants.SCHEDULE_ITERATION_LIST_COMPLETE,
    payload,
  };
};

export const scheduleIterationListError = (payload) => {
  return {
    type: schedulePaymentsConstants.SCHEDULE_ITERATION_LIST_ERROR,
    payload,
  };
};

export const stopSchedulePaymentRequest = (payload) => {
  return {
    type: schedulePaymentsConstants.STOP_SCHEDULE_PAYMENT_REQUEST,
    payload,
  };
};

export const stopSchedulePaymentComplete = (payload) => {
  return {
    type: schedulePaymentsConstants.STOP_SCHEDULE_PAYMENT_COMPLETE,
    payload,
  };
};

export const stopSchedulePaymentError = (payload) => {
  return {
    type: schedulePaymentsConstants.STOP_SCHEDULE_PAYMENT_ERROR,
    payload,
  };
};

export const clearStopSchedulePaymentCloseModal = () => {
  return {
    type: schedulePaymentsConstants.CLEAR_STOP_SCHEDULE_PAYMENT_CLOSE_MODAL,
  };
};

export const setSelectedSchedulePaymentsIterationDetails = (payload) => {
  return {
    type: schedulePaymentsConstants.SET_SELECTED_SCHEDULE_PAYMENTS_ITERATION_DETAILS,
    payload,
  };
};

export const setNavigateFrom = (payload) => {
  return {
    type: schedulePaymentsConstants.SET_NAVIGATE_FROM,
    payload,
  };
};

export const clearState = () => {
  return {
    type: schedulePaymentsConstants.CLEAR_STATE,
  };
};

export const clearNavigateFrom = () => {
  return {
    type: schedulePaymentsConstants.CLEAR_NAVIGATE_FROM,
  };
};

export const clearChangeIterationStatusSuccess = () => {
  return {
    type: schedulePaymentsConstants.CLEAR_CHANGE_ITERATION_STATUS_SUCCESS,
  };
};

export const setActiveListType = (payload) => {
  return {
    type: schedulePaymentsConstants.SET_ACTIVE_LIST_TYPE,
    payload,
  };
};

export const setFilterPaymentStatus = (payload) => {
  return {
    type: schedulePaymentsConstants.SET_FILTER_PAYMENT_STATUS,
    payload,
  };
};

export const setScheduleDetailActiveTab = (payload) => {
  return {
    type: schedulePaymentsConstants.SET_SCHEDULE_DETAIL_ACTIVE_TAB,
    payload,
  };
};
